import moment from 'moment'

function now() {
  return new Date().getTime() / 1000
}

function dateInSeconds(value) {
  return moment(value, 'DD.MM.YYYY').unix()
}

const validatorMinDays = {
  getMessage(field, args) {
    return null;
  },
  validate(value, [minDays]) {
    let rangeBeginning = now() + Number(minDays) * 24 * 3600;
    return dateInSeconds(value) >= rangeBeginning;
  }
}

const validatorMaxDays = {
  getMessage(field, args) {
    return null;
  },
  validate(value, [maxDays]) {
    let rangeEnd = now() + Number(maxDays) * 24 * 3600
    return dateInSeconds(value) <= rangeEnd;
  }
}

export default {
  maxDays: validatorMaxDays,
  minDays: validatorMinDays
}